import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import PropTypes, { any } from 'prop-types';

import Modal from '../../../Modal/ReactBootstrapModal';
import AddPhoto from '../../../PhotoUpload/AddPhoto';
import { uploadTempPhoto, clearTempPhoto as clearTempPhotoAction } from '../../../../actions/upload-actions';
import Img from '../../../Img';
import PhotoEditor from './SponsorPhotoEditor';
import { cropEventSponsor } from '../../../../actions/club-actions';
import appconfig from '../../../../../config';
import styles from './AddEventSponsors.scss';

const defaultUrl = '/img/icons/uploadSponsorLogo.png';
const sponsorTiers = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
    10: 'ten',
};
const EventSponsors = ({ tier, updateShowDeleteConfirmPopup, setToDeleteTier, tiers = { tiers: [] }, setTiers, clubId }) => {
    const dispatch = useDispatch();
    const { displayOrder, shortName, placeholder } = tier;
    const [openPhotoEditor, setOpenPhotoEditor] = useState(false);
    const [sponsorToUpdate, setSponsorToUpdate] = useState({});
    const [nameIsTouched, setNameIsTouched] = useState({

    });
    const logoInputRef = useRef();
    const uploads = useSelector(({ uploads }) => uploads);
    useEffect(() => {
        setTiers((prevState) => {
            return {
                ...prevState,
                nameInputsAreTouched: false,
            };
        });
    }, []);

    const existingLogos = tiers?.tiers.reduce((acc, cur) => {
        const tempPhotoUris = cur.sponsors?.map(({ imageFile }) => imageFile) || [];
        return [...acc, ...tempPhotoUris];
    }, []).filter(url => url !== defaultUrl);

    // image upload
    const handleUploadLogoStart = () => {
        setOpenPhotoEditor(true);
    };
    const handleUploadPhoto = (file) => {
        dispatch(uploadTempPhoto(file));
    };

    const handleTierNameChange = (e) => {
        e.persist();
        const nameInputsAreTouched = Object.values(nameIsTouched).some((touch) => !!touch);

        if (typeof e?.target?.value === 'string') {
            setTiers((prevState) => {
                const updatedData = [...prevState.tiers].map((cur) => (cur.displayOrder === displayOrder ? { ...cur, shortName: e.target?.value || '' } : cur));
                return { tiers: [...updatedData], nameInputsAreTouched };
            });
        }
    };
    const handleSponsorUrlChange = (e, i) => {
        e.persist();

        setTiers((prevState) => {
            const tiers = prevState.tiers.map((tier) => {
                if (tier.displayOrder === displayOrder) {
                    if (typeof e?.target?.value === 'string') {
                        const updatedSponsors = tier?.sponsors.map((sponsor, index) => (index === i ? { ...sponsor, callToActionURL: e.target.value, sponsorName: sponsor.sponsorName || e.target.value || '' } : sponsor));
                        return { ...tier, sponsors: updatedSponsors };
                    }
                }
                return tier;
            });
            return { tiers };
        });
    };

    const handleDeleteRow = (index) => {
        if (tier?.sponsors.length > 1) {
            const updatedRows = tier?.sponsors.filter((_, i) => i !== index);

            const updatedSponsors = updatedRows.map((sponsor, index) => {
                return {
                    ...sponsor,
                    displayOrder: index + 1,
                };
            });
            setTiers((prevState) => {
                if (prevState.tiers.length > 0) {
                    const tiers = [...prevState.tiers]?.map((t) => (t.displayOrder === displayOrder ? { ...t, sponsors: updatedSponsors } : t));
                    return { tiers };
                }
            });
        }
    };

    const addSponsor = () => {
        const order = tier?.sponsors?.length === 0 ? 1 : (tier?.sponsors[tier?.sponsors.length - 1].displayOrder) + 1;
        const newSponsor = { sponsorName: '', callToActionURL: '', imageFile: defaultUrl, displayOrder: order };
        setTiers((prevState) => {
            if (prevState.tiers.length > 0) {
                const tiers = prevState?.tiers.map((t) => (t.displayOrder === displayOrder ? { ...t, sponsors: [...t.sponsors, newSponsor] } : t));
                return { tiers: [...tiers] };
            }
        });
    };
    const updatedSponsorLogo = (data) => {
        const { imageFile } = data;
        const sponsorDisplayOrder = sponsorToUpdate.displayOrder;
        setTiers((prevState) => {
            const tiers = prevState?.tiers.map((tier) => {
                if (tier.displayOrder === displayOrder) {
                    const updatedSponsors = tier?.sponsors.map((sponsor) => (sponsor.displayOrder === sponsorDisplayOrder ? { ...sponsor, imageFile } : sponsor));
                    return { ...tier, sponsors: updatedSponsors };
                }
                return tier;
            });
            return { tiers };
        });
    };
    const deleteTier = () => {
        setToDeleteTier(tier);
        updateShowDeleteConfirmPopup(true);
    };

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const reorderedSponsors = Array.from(tier?.sponsors);
        const [removed] = reorderedSponsors.splice(result.source.index, 1);
        reorderedSponsors.splice(result.destination.index, 0, removed).map((sponsor, index) => {
            return {
                ...sponsor,
                displayOrder: index + 1,
            };
        });

        const updaterSponsorOrder = reorderedSponsors.map((sponsor, index) => {
            return {
                ...sponsor,
                displayOrder: index + 1,
            };
        });
        setTiers((prevState) => {
            const tiers = prevState?.tiers.map((tier) => {
                if (tier.displayOrder === displayOrder) {
                    return {
                        ...tier,
                        sponsors: [...updaterSponsorOrder],
                    };
                }
                return tier;
            });
            return { tiers };
        });
    };

    const sortedSponsors = tier?.sponsors?.sort((a, b) => a.displayOrder - b.displayOrder);

    return (

        <div className={`${styles.addSponsorModal}`}>
            <div className="d-flex flex-col">
                <div className="d-flex justify-content-between">
                    <h2 className={`${styles.heading}`}>Sponsor tier {sponsorTiers[displayOrder]}</h2>
                    {tier.displayOrder !== 0 && (
                        <span className="close-icon" onClick={deleteTier}>
                            <i className="fal fa-trash-alt" />
                        </span>
                    )}
                </div>
                <div className={`${styles.addSponsorInputField}`}>
                    <input
                        type="text"
                        id="tierName"
                        value={shortName}
                        onChange={(e) => handleTierNameChange(e)}
                        placeholder={placeholder}
                        onFocus={() => {
                            setNameIsTouched((prevState) => {
                                return { ...prevState, id: true };
                            });
                        }}
                    />
                </div>
                {(shortName && shortName.trim() === '' && nameIsTouched.id) ? <div className="text-error text-small">This field is required</div> : null}
            </div>
            <div className={`${styles.addSponsorshipLogos}`}>
                {tier?.sponsors?.length > 0 && (
                    <h2 className={`${styles.heading}`}>Sponsorship logos</h2>
                )}

                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="sponsorLogos">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {sortedSponsors?.map((sponsor, index) => {
                                    const imageUrl = `${appconfig.apiHost}/v2/tms/events/${clubId}/images/sponsorlogos/${sponsor.imageFile}`;
                                    return (
                                        <Draggable key={sponsor.displayOrder} draggableId={String(index)} index={index}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    className={`${styles.addSponsorshipLogosRow}`}
                                                >

                                                    <img
                                                        src={'/img/icons/addSponsorMenu.svg'}
                                                        alt="menu"
                                                        {...provided.dragHandleProps}
                                                    />
                                                    <AddPhoto
                                                        maxSize={512}
                                                        uploadPhoto={handleUploadPhoto}
                                                        uploadStart={handleUploadLogoStart}
                                                        text={'Upload'}
                                                        // eslint-disable-next-line react/style-prop-object
                                                        style={2}
                                                        inputRef={logoInputRef}
                                                    />
                                                    {/* upload photo */}
                                                    <div
                                                        onClick={() => {
                                                            console.log('logoInputRef', logoInputRef);
                                                            if (logoInputRef.current) {
                                                                setSponsorToUpdate(sponsor);
                                                                logoInputRef.current.click();
                                                            }
                                                        }}
                                                        className={`${styles.uploadLogoInput} ${sponsor.imageFile === defaultUrl ? styles.defaultUploadIcon : ''}`}

                                                    >
                                                        <Img
                                                            className={''}
                                                            src={`${sponsor.imageFile === defaultUrl ? defaultUrl : imageUrl}`}
                                                            onError={(e) => {
                                                                e.target.src = '';
                                                                e.target.srcset = '';
                                                            }}

                                                        />
                                                    </div>

                                                    {openPhotoEditor && (

                                                        <Modal backdropClassName={styles.backdrop} data-backdrop={false} visible={openPhotoEditor} className={`${styles.existingLogosModal} popup-lg ${existingLogos.length === 0 ? styles.noExistingLogos : ''}`} dialogClassName="modal-lg">

                                                            <div className="">
                                                                <div className={`${styles.photoEditorModal}`}>

                                                                    <PhotoEditor
                                                                        showEditor={openPhotoEditor}
                                                                        closeEditor={() => setOpenPhotoEditor(false)}
                                                                        imageUrl={uploads.tempPhotoUrl}
                                                                        data-testid="modal.event-edit.sponsor-photo-editor"
                                                                        uploadCropData={async (values) => {
                                                                            const res = await dispatch(cropEventSponsor(clubId, values));
                                                                            const url = res.data.sponsorUrl;
                                                                            const fileName = url.split('/').pop();
                                                                            updatedSponsorLogo({ imageFile: fileName });
                                                                            setOpenPhotoEditor(false);
                                                                            dispatch(clearTempPhotoAction(true));
                                                                        }}
                                                                        type="event_sponsor_logo"
                                                                    />
                                                                </div>
                                                                <div className={`${styles.existingLogos}`}>
                                                                    {existingLogos.length > 0 && existingLogos.map((logoUrl) => (

                                                                        <div key={logoUrl} className={`${styles.uploadLogoInput} ml16`}>
                                                                            <img
                                                                                onClick={() => {
                                                                                    updatedSponsorLogo({ imageFile: logoUrl });
                                                                                    setOpenPhotoEditor(false);
                                                                                }}
                                                                                src={`${appconfig.apiHost}/v2/tms/events/${clubId}/images/sponsorlogos/${logoUrl}`}
                                                                            />
                                                                        </div>
                                                                    ))}

                                                                </div>

                                                            </div>
                                                        </Modal>
                                                    )}
                                                    <div className={`${styles.addSponsorInputField}`}>
                                                        <input
                                                            type="text"
                                                            id={`sponsorLogos-${index}`}
                                                            value={sponsor.callToActionURL}
                                                            onChange={(e) => handleSponsorUrlChange(e, index)}
                                                            placeholder="Add a URL (optional)"
                                                        />
                                                    </div>
                                                    <div
                                                        onClick={() => handleDeleteRow(index)}
                                                        style={{ cursor: 'pointer', margin: 'auto' }}
                                                    >

                                                        <img
                                                            height={14}
                                                            src={'/img/icons/deleteRowIcon.svg'}
                                                            alt="delete_row"

                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
            <div className={`${styles.addSponsorsBtn}`} onClick={addSponsor}>
                <img src={'/img/icons/addSponsorTierIcon.svg'} alt="add sponsor" />
                <span>Add sponsor</span>
            </div>
        </div>
    );
};

EventSponsors.propTypes = {
    tier: PropTypes.objectOf(any).isRequired,
    updateShowDeleteConfirmPopup: PropTypes.func.isRequired,
    setToDeleteTier: PropTypes.func.isRequired,
    tiers: PropTypes.objectOf(any).isRequired,
    setTiers: PropTypes.func.isRequired,
    displayOrder: PropTypes.number,
    shortName: PropTypes.string,
    placeholder: PropTypes.string,
    isCurrentMemberAdmin: PropTypes.bool,
    handleRegClick: PropTypes.func,
};
EventSponsors.defaultProps = {
    displayOrder: 0,
    shortName: '',
    placeholder: '',
    isCurrentMemberAdmin: false,
    handleRegClick: () => { },
};
export default EventSponsors;
